/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Load_PlaceholderInputs */

const en_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a preset`)
};

const fr_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un prereglage`)
};

const de_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung aus.`)
};

const it_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset`)
};

const ru_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку`)
};

const es_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un ajuste preestablecido`)
};

const zh_cn2_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设`)
};

const ja_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択`)
};

const hi_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रीसेट चुनें`)
};

const pt_pt2_video_export_export_preset_load_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma predefinição`)
};

/**
* | output |
* | --- |
* | "Select a preset" |
*
* @param {Video_Export_Export_Preset_Load_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_load_placeholder = /** @type {((inputs?: Video_Export_Export_Preset_Load_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Load_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_load_placeholder(inputs)
	if (locale === "de") return de_video_export_export_preset_load_placeholder(inputs)
	if (locale === "it") return it_video_export_export_preset_load_placeholder(inputs)
	if (locale === "ru") return ru_video_export_export_preset_load_placeholder(inputs)
	if (locale === "es") return es_video_export_export_preset_load_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_load_placeholder(inputs)
	if (locale === "ja") return ja_video_export_export_preset_load_placeholder(inputs)
	if (locale === "hi") return hi_video_export_export_preset_load_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_load_placeholder(inputs)
	return en_video_export_export_preset_load_placeholder(inputs)
});